import BaseError from "./Error/BaseError";
/*
 * @Author: freedeng
 * @Date: 2019-06-18 10:39:39
 * @Last Modified by: freedeng
 * @Last Modified time: 2019-07-25 19:54:50
 */
/**
 * 用来封装返回值
 */
var Result = /** @class */ (function () {
    function Result(error, data) {
        if (error !== undefined) {
            if (error.errorType === undefined) { // instanceOf判断不对 只能用这种恶心的办法了  尴尬啊 
                this.error = BaseError.copyFrom(error);
            }
            else {
                this.error = error;
            }
        }
        if (data !== undefined) {
            this.data = data;
        }
    }
    return Result;
}());
export { Result };
//# sourceMappingURL=Result.js.map